<template>
  <div>
    <b-spinner
      v-show="isLoading"
      variant="success"
      label="Spinning"
    ></b-spinner>
    <div id="amazon-button-widget" v-show="!isLoading">
      <div class="d-flex justify-content-between mb-3">
        <div id="AmazonPayButton"></div>
        <div class="button area">
          <b-button
            variant="outline-primary"
            @click="onDonate"
            v-show="toggleBtnDonate"
            >Amazon Donate</b-button
          >
          <b-button
            variant="outline-secondary"
            @click="onCloseDonate"
            v-show="!toggleBtnDonate"
            >Close Donate</b-button
          >
        </div>
      </div>

      <div v-if="showWidgetButton" id="walletWidgetDiv"></div>

      <b-form-input type="text" id="orderReferenceId" value="none" />

      <components :is="showDonateWidget"></components>

      <br />
      <b-button @click="logOut" id="logOut">log out</b-button>
    </div>
  </div>
</template>
<script>
import donateButton from "../donateButton";
export default {
  name: "amazonPayButton",
  components: {
    donateButton
  },
  data() {
    return {
      isLoading: false,
      errorWidget: false,
      showDonateWidget: null,
      showPaymnetButton: true,
      toggleBtnDonate: true,
      accessToken: null,
      status: false,
      showWidgetButton: false,
      clientId: "amzn1.application-oa2-client.24be971d2d234c1a9a500e1e21255239",
      sellerId: "AF5CUPSCUJEGH",
      redirectUrl: "http://localhost:8080/focus",
      scope: "profile payments:widget"
    };
  },
  mounted() {
    this.initObserverFunction();
  },
  beforeMount() {
    this.initMethods();
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
      this.showPayButton();
    }, 300);
  },
  methods: {
    onCloseDonate() {
      this.showDonateWidget = null;
      this.toggleBtnDonate = true;
    },
    onDonate() {
      console.log("on Donate");
      setTimeout(() => {
        let amazonAPIscript = document.createElement("script");

        amazonAPIscript.setAttribute(
          "src",
          "https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js"
        );

        amazonAPIscript.async = true;

        document.head.appendChild(amazonAPIscript);
        this.toggleBtnDonate = false;
        this.showDonateWidget = "donateButton";
      }, 200);
    },
    removeDublicateDonateBtn() {
      const dntBtn = window.document.querySelectorAll("#donationButton")[0];
      if (dntBtn === undefined) return;
      if (dntBtn.childElementCount > 1) {
        for (let i = 0; dntBtn.childElementCount > i; i++) {
          dntBtn.children[i].remove();
        }
      }
    },
    initMethods() {
      const getAllScripts = document.scripts;
      if (getAllScripts.length > 0) {
        for (let i = 0; getAllScripts.length > i; i++) {
          if (
            document.scripts.item(i).src ===
            "https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js"
          ) {
            this.status = true;
          }
        }
      }

      if (!this.status) {
        let amazonAPIscript = document.createElement("script");

        amazonAPIscript.setAttribute(
          "src",
          "https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js"
        );

        amazonAPIscript.async = true;

        document.head.appendChild(amazonAPIscript);
      }
    },
    initObserverFunction() {
      const self = this;
      function getURLParameter(name, source) {
        return (
          decodeURIComponent(
            (new RegExp("[?|&|#]" + name + "=" + "([^&]+?)(&|#|;|$)").exec(
              source
            ) || [, ""])[1].replace(/\+/g, "%20")
          ) || null
        );
      }

      let accessToken = getURLParameter("access_token", location.hash);

      if (typeof accessToken === "string" && accessToken.match(/^Atza/)) {
        window.accessToken = accessToken;
        document.cookie =
          "amazon_Login_accessToken=" + accessToken + ";path=/;secure";
      }
      window.onAmazonLoginReady = function() {
        window.amazon.Login.setClientId(self.clientId);
        window.amazon.Login.setUseCookie(true);
      };

      window.onAmazonPaymentsReady = function() {
        self.showWalletWidget();
      };
    },
    showWalletWidget() {
      // Wallet
      const self = this;
      if (window.accessToken === undefined) {
        this.showWidgetButton = false;
        return;
      }
      window.orderReferenceId = "";
      new window.OffAmazonPayments.Widgets.Wallet({
        sellerId: "AF5CUPSCUJEGH",
        design: {
          size: {
            width: "425px",
            height: "260px"
          }
        },
        amazonOrderReferenceId: window.orderReferenceId,
        // Add the onOrderReferenceCreate function to
        // generate an Order Reference ID.
        onOrderReferenceCreate: function(orderReference) {
          // Use the following cod to get the generated Order Reference ID.
          window.orderReferenceId = orderReference.getAmazonOrderReferenceId();

          let el;
          if ((el = document.getElementById("orderReferenceId"))) {
            el.value = window.orderReferenceId;
          }
        },
        onPaymentSelect: function(orderReference) {
          // Replace this code with the action that you want to perform
          // after the payment method is selected.
          console.log("onPaymentSelect", orderReference);
          // Ideally this would enable the next action for the buyer
          // such as a "Continue" or "Place Order" button.
        },
        onError: function(error) {
          // Error handling code
          // We also recommend that you implement an onError handler in your code.
          // @see https://payments.amazon.com/documentation/lpwa/201954960
          // self.errorWidget = true;
          self.showWidgetButton = false;
          console.log(
            "OffAmazonPayments.Widgets.Wallet",
            error.getErrorCode(),
            error.getErrorMessage()
          );
        }
      }).bind("walletWidgetDiv");
    },
    showPayButton() {
      const self = this;
      let authRequest;
      window.OffAmazonPayments.Button("AmazonPayButton", self.sellerId, {
        type: "PwA",
        color: "Gold",
        size: "medium",
        authorization: function() {
          const loginOptions = {
            scope: "profile payments:widget",
            popup: true
          };
          authRequest = window.amazon.Login.authorize(loginOptions, function(
            t
          ) {
            window.accessToken = t.access_token;
            window.document.cookie =
              "amazon_Login_accessToken=" + window.accessToken + ";path=/";

            if (!self.showWidgetButton) {
              self.showWidgetButton = true;

              self.showWalletWidget(null);

              self.initMethods();
              setTimeout(() => {
                self.removeDublicateDonateBtn();
              }, 200);
            }
          });
        },
        onError: function(error) {
          // your error handling code.
          console.log(
            "The following error occurred: " +
              error.getErrorCode() +
              " - " +
              error.getErrorMessage()
          );
        }
      });
    },
    showLoginButton() {
      let authRequest;
      window.OffAmazonPayments.Button("AmazonLoginButton", self.sellerId, {
        type: "LwA",
        color: "Gold",
        authorization: function() {
          const loginOptions = {
            scope: self.scope,
            popup: true
          };
          authRequest = window.amazon.Login.authorize(loginOptions, function(
            n
          ) {
            console.log("n", n);
          });
        },
        onError: function(error) {
          // something bad happened
          console.log("login", error);
        }
      });
    },
    logOut() {
      window.amazon.Login.logout();
      window.document.cookie =
        "amazon_Login_accessToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      // window.location.href = "/";
      window.document.getElementById("orderReferenceId").value = "none";
      this.showWidgetButton = false;
    }
  }
};
</script>
<style lang="scss" scope>
#orderReferenceId {
  width: 50%;
  text-align: center;
}

div#amazon-button-widget {
  text-align: center;
}

#logOut {
  margin-top: 20px;
}
</style>
